/**
 * 系统管理 菜单管理
 */
<template>
  <div>
    <!-- 主体内容 -->
    <el-row :gutter="20">
      <!-- title -->
      <div class="modt-box">菜单管理</div>
      <!-- <el-col :span="4"> </el-col> -->
      <el-col :span="6">
        <div class="mod-btnbox">
          <el-button size="small" type="primary" @click="onAll(true)">全部展开</el-button>
          <el-button size="small" type="primary" @click="onAll(false)">全部压缩</el-button>
        </div>
        <el-tree class="treeclass" ref="tree" :data="treeData" :default-expand-all="alls" 
        :props="defaultProps" @check-change="handleClick" check-strictly node-key="id" show-checkbox :key="treeKey"></el-tree>
      </el-col>
      <el-col :span="18">
        <div class="mod-btnbox">
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addModule">添加</el-button>
        </div>
        <el-form ref="form" :model="form" label-width="80px" :rules="rules" class="treeclass">
          <div class="modt-box1" v-if="name">{{name}}</div>
          <el-form-item label="父级菜单" prop="parentId">
            <el-select size="small" v-model="form.parentId" placeholder="请选择" class="selectw">
              <el-option v-for="parm in fmenu" :key="parm.id" :label="parm.name" :value="parm.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="菜单名称" prop="menuName">
            <el-input size="small" v-model="form.menuName"></el-input>
          </el-form-item>
          <!-- <el-form-item label="权限Id" prop="permissionId">
            <el-input type="number" size="small" v-model="form.permissionId" @input="change"></el-input>
          </el-form-item> -->
          <el-form-item label="初始权限" prop="permissionId">
            <el-select size="small" v-model="form.permissionId" placeholder="请选择" class="selectw">
              <el-option v-for="parm in qmenu" :key="parm.id" :label="parm.remark" :value="parm.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="顺序" prop="menuSort">
            <el-input type="number" size="small" v-model="form.menuSort" @input="changeSort"></el-input>
          </el-form-item>
          <el-form-item label="图标" prop="menuIcon">
            <el-input size="small" v-model="form.menuIcon"></el-input>
          </el-form-item>
          <el-form-item label="URL" prop="menuUrl">
            <el-input size="small" v-model="form.menuUrl"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input size="small" v-model="form.remark"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" v-show="showdelete" @click="saveModule('form')">保存</el-button>
            <el-button size="small" type="primary" v-show="!showdelete" @click="addModuleMenu('form')">添加</el-button>
            <el-button size="small" type="primary" v-show="showdelete" @click="deleteModule">删除</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script >
import {
  ModuleList,
  ModuleSave,
  ModuleAdd,
  ModuleDelete,
  ModuleTree
} from '../../api/userMG'
export default {
  data() {
    return {
      showdelete: false,
      alls:true,
      treeKey:"",
      treeData: [],
      defaultProps: {
        children: 'childs',
        label: 'name'
      },
      form: {
        parentId: 0,
        menuName: "",
        menuIcon: "",
        menuUrl: "",
        menuSort: null,
        permissionId: 0,
        remark: ""
      },
      name:null,
      moduleId:null,
      // rules表单验证
      rules: {
        parentId: [
          { required: true, message: '请选择父级菜单', trigger: 'blur' }
        ],
        menuName: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ],
        menuSort: [
          { required: true, message: '请输入菜单顺序', trigger: 'blur' }
        ],
        permissionId: [
          { required: true, message: '请输入权限ID', trigger: 'blur' }
        ]
      },
      fmenu: [],
      qmenu: [],
    }
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据
    getdata() {
      ModuleList().then(res => {
          if(res.code == 0){
            this.treeData = res.data.list
            let arr = [{id:0,name:'顶级'}]
            this.fmenu = arr.concat(res.data.list)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单管理列表失败，请稍后再试！')
        });
      ModuleTree().then(res => {
          if(res.code == 0){
            let arr = [{id:0,remark:'无'}]
            this.qmenu = arr.concat(res.data.list)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单管理列表失败，请稍后再试！')
        })
      
    },
    change(ev){
      // this.form.permissionId = parseInt(ev)
    },  
    changeSort(ev){
      // this.form.menuSort = parseInt(ev)
    },
    onAll(flag){
      this.treeKey = +new Date();
      this.alls = flag
    },
    // 添加
    addModule() {
      this.showdelete = false
      this.moduleId = null
      this.name = null
      this.$refs.tree.setCheckedNodes([])
      this.form = {
          parentId: 0,
          menuName: '',
          menuIcon: '',
          menuUrl: '',
          menuSort: null,
          permissionId: 0,
          remark: ''
        }
    },
    // 复选变单选
    handleClick(data, checked, node) {
      console.log(data)
      if (checked) {
        this.$refs.tree.setCheckedNodes([])
        this.$refs.tree.setCheckedNodes([data])
        this.name = data.name
        this.moduleId = data.id
        this.showdelete = true
        this.form = {
          parentId: data.parentId,
          menuName: data.name,
          menuIcon: data.icon,
          menuUrl: data.url,
          menuSort: data.sort,
          permissionId: data.permissionId,
          remark: data.remark
        }
      }else {
        // this.name = null
        // this.moduleId = null
        // this.showdelete = false
        // this.form = {
        //   parentId: 0,
        //   menuName: '',
        //   menuIcon: '',
        //   menuUrl: '',
        //   menuSort: null,
        //   permissionId: 0,
        //   remark: ''
        // }
      }
    },
    // 编辑保存菜单
    saveModule(editData) {
      // alert(this.form.permissionId)
      this.$refs[editData].validate(valid => {
        if (valid) {
          let params = {
            parentId: this.form.parentId,
            menuName: this.form.menuName,
            menuIcon: this.form.menuIcon,
            menuUrl: this.form.menuUrl,
            menuSort: this.form.menuSort,
            permissionId: this.form.permissionId,
            remark: this.form.remark,
            id:this.moduleId
          }
          ModuleSave(params)
            .then(res => {
              if(res.code == 0){
                this.$message({type: 'success',message:'菜单管理列表保存成功！'})
                this.form =  {
                  parentId: 0,
                  menuName: "",
                  menuIcon: "",
                  menuUrl: "",
                  menuSort: null,
                  permissionId: 0,
                  remark: ""
                },
                this.getdata()
                this.$root.Bus.$emit('upmenu')
              }else{
                this.$message.error(res.message)
              }
            })
            .catch(err => {
              this.$message.error('菜单管理列表保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 添加菜单
    addModuleMenu(editData) {
      // alert(this.form.permissionId)
      this.$refs[editData].validate(valid => {
        if (valid) {
          ModuleAdd(this.form)
            .then(res => {
              if(res.code == 0){
                this.$message({type: 'success',message:'菜单管理列表添加成功！'})
                this.form =  {
                  parentId: 0,
                  menuName: "",
                  menuIcon: "",
                  menuUrl: "",
                  menuSort: null,
                  permissionId: 0,
                  remark: ""
                },
                this.getdata()
                this.$root.Bus.$emit('upmenu')
              }else{
                this.$message.error(res.message)
              }
            })
            .catch(err => {
              this.$message.error('菜单管理列表添加失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除菜单
    deleteModule() {
      ModuleDelete(this.moduleId)
        .then(res => {
          if(res.code == 0){
            this.name = null
            this.moduleId = null
            this.showdelete = false
            this.form = {
              parentId: 0,
              menuName: '',
              menuIcon: '',
              menuUrl: '',
              menuSort: null,
              permissionId: 0,
              remark: ''
            }
            this.getdata()
            this.$root.Bus.$emit('upmenu')
            this.$message({type: 'success',message:'菜单管理列表删除成功！'})
          }else{
            this.$message.error(res.message)
          }
          // this.getmenu()
        })
        .catch(err => {
          this.$message.error('菜单管理列表删除失败，请稍后再试！')
        })
    }
  }
}
</script>

<style>
.user-search {
  margin-top: 20px !important;
}
.user-search td {
  margin-top: 20px !important;
}
.userRole {
  width: 100%;
}
.el-table__expanded-cell {
  padding: 0px !important;
  margin: 0px !important;
}
.modt-box {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #fafcff;
  border: 1px solid #e4ebed;
  border-radius: 6px;
  text-align: center;
  color: #334157;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 24px;
}
.modt-box1 {
  width: 100%;
  border-radius: 6px;
  /* text-align: center; */
  padding-left: 6px;
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 18px;
}
.mod-btnbox {
  margin-bottom: 20px;
}
.treeclass {
  border: 1px solid #e4ebed;
  padding: 20px;
  border-radius: 6px;
  background-color: #fafcff;
}
.selectw {
  width: 100%;
}
</style>
 
 


// WEBPACK FOOTER //
// src/views/system/Module.vue